import type { CSSProperties, ReactNode } from 'react';
import { Tooltip } from '@odo/shared-ui';

const PRIMARY_TEXT_CLASSES =
    'text-[10px] uppercase tracking-[0.18em] font-bold text-gray-400 font-inter whitespace-nowrap';
const SECONDARY_TEXT_CLASSES = 'text-[10px] font-normal text-gray-500 font-inter whitespace-nowrap';
const COLUMN_CLASSES = 'max-h-full overflow-hidden text-ellipsis';
const VERTICAL_COLUMN_STYLE: CSSProperties = {
    writingMode: 'vertical-rl',
    transform: 'rotate(180deg)'
};

interface SideRailVerticalLabelProps {
    label: string;
    secondaryLabel?: string;
    tooltip?: ReactNode;
    tooltipSide: 'left' | 'right';
}

function SingleVerticalLabel({ label }: { label: string }) {
    return (
        <div
            className="absolute top-2 left-1/2 -translate-x-1/2 mt-2"
            style={{
                writingMode: 'vertical-rl',
                transform: 'translateX(-50%) rotate(180deg)'
            }}
        >
            <span className={PRIMARY_TEXT_CLASSES}>{label}</span>
        </div>
    );
}

function SideRailVerticalLabel({
    label,
    secondaryLabel,
    tooltip,
    tooltipSide
}: SideRailVerticalLabelProps) {
    if (!secondaryLabel && !tooltip) return <SingleVerticalLabel label={label} />;

    return (
        <Tooltip content={tooltip} side={tooltipSide} focusable>
            <div className="absolute top-4 bottom-3 left-1/2 -translate-x-1/2 flex items-start gap-0.5">
                <span
                    className={`${PRIMARY_TEXT_CLASSES} ${COLUMN_CLASSES}`}
                    style={VERTICAL_COLUMN_STYLE}
                >
                    {label}
                </span>
                {secondaryLabel && (
                    <span
                        className={`${SECONDARY_TEXT_CLASSES} ${COLUMN_CLASSES}`}
                        style={VERTICAL_COLUMN_STYLE}
                    >
                        {secondaryLabel}
                    </span>
                )}
            </div>
        </Tooltip>
    );
}

export { SideRailVerticalLabel };
